import React, { useState, useEffect } from "react";
import { Redirect, Route, Link, useParams } from "react-router-dom";

import Faqs from "../components/Faqs";
import Swal from "sweetalert2";

//New structure

import GameSlider from "elements/gameElements/GameSlider";
import CategoryGameContainer from "elements/gameElements/CategoryGameContainer";
import Winners from "../components/Winners";
import HomeBanner from "elements/HomeBanner";
// import StepRightUp from "elements/home/StepRightUp";
// import BringOn from "elements/home/BringOn";
import GameMenu from "elements/gameElements/GameMenu";
import HomeFullBanner from "elements/HomeFullBanner";
import FeatureItems from "elements/home/FeatureItems";
import SeoContent from "components/SeoContent";

export default function Landing(props) {
  const [seconds, setSeconds] = useState(4083958);
  const params = useParams();
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((seconds) => seconds + 1);
    }, 60);
    return () => clearInterval(interval);
  }, []);

  const [categoryName, setCategoryName] = useState("Slots");
  const __ = (text) => text;

  useEffect(() => {
    if (params.status == "true") {
      Swal.fire({
        title: "Success!",
        text: "Successfully bought coins package.",
        icon: "success",
        background: "#2e2e2e", // Dark background color
        color: "#fff", // White text color
        customClass: {
          popup: "dark-theme-popup",
          title: "dark-theme-title",
          content: "dark-theme-content",
        },
      });
    } else if (params.status == "false") {
      Swal.fire({
        title: "Warning!",
        text: "Buying coins package failed!",
        icon: "warning",
        background: "#2e2e2e", // Dark background color
        color: "#fff", // White text color
        customClass: {
          popup: "dark-theme-popup",
          title: "dark-theme-title",
          content: "dark-theme-content",
        },
      });
    }
  }, [params.status]);

  return (
    <>
      <div className="container-xxl">
        {/* <Banner {...props} /> */}
        <HomeFullBanner {...props} callFrom={"landing"} />
        {/* <TopShortMenu /> */}

        {/* <div className="gameHeading">{__("Sweeplay Games")}</div> */}
        {/* <GameSlider
          categoryName="Popular"
          category="video_slots"
          perPage="20"
          {...props}
        /> */}
        {/* <FeatureItems {...props} /> */}
        {/* {<GameMenu callFromSlider={false} {...props} />} */}

        <CategoryGameContainer {...props} />
        <Winners {...props} />

        <br />
        <GameSlider
          categoryName="New"
          categoryLabel={__("New")}
          menuBar={false}
          category="new"
          perPage="20"
          title={true}
          {...props}
        />
        <br />
        <GameSlider
          categoryName="Table Games"
          categoryLabel={__("Table Games")}
          menuBar={false}
          category="table_games"
          perPage="20"
          title={true}
          {...props}
        />
        <br />

        {/* <StepRightUp {...props} /> */}

        {/* <Faqs heading={true} {...props} /> */}
        {/* <BringOn {...props} /> */}

        <div className="singleItemBanner">
          <img
            alt=""
            className="bannerImg"
            src={require("../assets/chilirojo/images/banners/card-show.webp")}
          />
          {/* <img alt="" className="bannerBg" src={require('../assets/chilirojo/images/banners/footer-banner.webp')} /> */}
          <div className="bannercontent">
            <h3 className="headingText">Roll the Dice, Chase the Prize!</h3>
            <p>
              Feel the rush as cards flip and chips stack up in this high-stakes
              casino adventure. Test your luck and go for the big win!
            </p>
            <Link className="commonBtn pOneBtn">
              <svg
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_318_14432)">
                  <path
                    d="M13.8232 0.456055C6.64353 0.456055 0.823242 6.27635 0.823242 13.4561C0.823242 20.6358 6.64353 26.4561 13.8232 26.4561C21.003 26.4561 26.8232 20.6358 26.8232 13.4561C26.8232 6.27635 21.003 0.456055 13.8232 0.456055ZM10.2712 19.1103V7.80182L20.0646 13.4561L10.2712 19.1103Z"
                    fill="#05070B"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_318_14432">
                    <rect
                      width="26"
                      height="26"
                      fill="white"
                      transform="translate(0.823242 0.456055)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span>{__("Play Now")}</span>
            </Link>
          </div>
        </div>

        <Faqs heading={true} {...props} />
        <br />
        <br />
        <br />
        {/* <BringOn {...props} /> */}
        <SeoContent {...props} />
      </div>
    </>
  );
}
